import { REPORT_TYPE_DATA } from './constants/report';
import dayjs from 'dayjs';
import { REGEXP } from '@/constants/regexp';

export default {
  report_type: {
    name: 'report_type',
    title: '报表类型',
    type: 'select',
    config: {
      data: REPORT_TYPE_DATA,
    },
    clearable: true,
  },
  report_title: {
    name: 'report_title',
    title: '日报名称',
    type: 'search',
  },
  report_id: {
    name: 'report_id',
    title: '日报ID',
    type: 'search',
    config: {
      placeholder: '请输入日报ID',
    },
    rules: [
      {
        pattern: REGEXP.number,
        message: '请输入数字类型，形如：100',
      },
    ],
  },
  advertiser_daily_report_date: {
    name: 'report_date',
    title: '日报分区',
    type: 'date-picker',
    defaultValue: {
      start_time: dayjs(new Date()).add(-6, 'day')
        .format('YYYY-MM-DD'),
      end_time: dayjs(new Date()).add(0, 'day')
        .format('YYYY-MM-DD'),
    },
    config: {
      useNewUI: true,
      type: 'range',
      optionalEndRelativeDays: 0,
      optionalStartRelativeDays: -6,
      longestRange: 6,
      horizontalPosition: 'right',
    },
    nameMap: {
      start_time: 'start_partition_time',
      end_time: 'end_partition_time',
    },
    clearable: false,
  },
};

